import { useContainer } from "@hooks";
import { IScreenProvider } from "../_types";

export const useScreenPropsProvider = () => {
  const container = useContainer();
  const screenProvider = container.resolve<IScreenProvider>('screen-provider');
  return screenProvider;
};
